module.exports = __webpack_public_path__ + "img/undraw_sync_files_xb3r.28783d27.svg";